module.exports = __webpack_public_path__ + "img/wine-detail-gallery.d8df4040.jpg";